'use client';

import {useEffect} from 'react';

export const ScrollTop = ({listName}: {listName: string}) => {
  useEffect(() => {
    document.documentElement.scrollTop = 0;
  }, [listName]);
  return null;
};
